import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ConditionsDialogComponent } from './dialog/conditions-dialog.component';
import { ConditionContainerComponent } from './dialog/condition-container.component';
import { CompositeConditionComponent } from './dialog/composite-condition.component';
import { SingleConditionComponent } from './dialog/single-condition.component';
import { DialogModule } from '../dialogs/dialogs.module';
import { TranslateModule } from '@ngx-translate/core';
import { CommonDirectivesModule } from '../directives/common-directives.module';
import { CommonComponentsModule } from '../components/common-components.module';
import { LookupDialogModule } from '../lookup-dialog-component/lookup-dialog.module';
import { CdDateTimePickerModule } from '../components/date-time-picker/cd-date-time-picker.module';

const components = [
  ConditionsDialogComponent, ConditionContainerComponent, CompositeConditionComponent, SingleConditionComponent
];

@NgModule({
  imports: [CommonModule, FormsModule, DialogModule, TranslateModule.forChild(),
    CommonDirectivesModule, CommonComponentsModule, LookupDialogModule, CdDateTimePickerModule, ReactiveFormsModule],
  declarations: components,
  providers: [],
  entryComponents: [ConditionsDialogComponent],
  exports: [ConditionsDialogComponent],
  schemas: []
})
export class ConditionsModule {
}
